/**
 * Parses organ names to match SVG IDs
 */
export const organParse = (organ: string): string => {
	if (organ.includes("blood")) {
		return "circulatory_system";
	}
	if (organ.includes("adipose")) {
		return "adipose";
	}
	if (organ.includes("adrenal")) {
		return "adrenal";
	}
	if (organ.includes("brain")) {
		return "brain";
	}
	if (organ.includes("heart")) {
		return "heart";
	}
	if (organ.includes("kidney")) {
		return "kidney";
	}
	if (organ.includes("liver")) {
		return "liver";
	}
	if (organ.includes("lung")) {
		return "lung";
	}
	if (organ.includes("muscle")) {
		return "muscle";
	}
	if (organ.includes("pancreas")) {
		return "pancreas";
	}
	if (organ.includes("small_intestine") || organ.includes("intestine")) {
		return "small_intestine";
	}
	if (organ.includes("spleen")) {
		return "spleen";
	}
	if (organ.includes("thyroid")) {
		return "thyroid";
	}
	if (organ.includes("stomach")) {
		return "stomach";
	}
	// Return the original organ name if no mapping is found
	return organ;
};

/**
 * Parses cellular location to match SVG IDs
 */
export const locationParse = (organelle: string): string | undefined => {
	if (organelle.includes("nucleus") || organelle.includes("nuclear")) {
		return "Nucleus";
	}
	if (organelle.includes("extracellular") || organelle.includes("cup")) {
		return "Extracellular_Space";
	}
	if (organelle.includes("cytoskeleton")) {
		return "Cytoskeleton";
	}
	if (organelle.includes("acrosomal") || organelle.includes("plasma")) {
		return "Plasma_Membrane";
	}
	if (organelle.includes("mitochondrion") || organelle.includes("mitochondrial")) {
		return "Mitochondrion";
	}
	if (organelle.includes("intracellular") || organelle.includes("cytoplasm") || organelle.includes("cytosol")) {
		return "Cytosol";
	}
	if (organelle.includes("endoplasmic")) {
		return "ER";
	}
	if (organelle.includes("Golgi")) {
		return "Golgi_apparatus";
	}
	if (organelle.includes("endosome")) {
		return "Endosome";
	}

	return undefined;
};

/**
 * Get body type based on sex
 */
export const getBodyType = (sex: string | null): 'male' | 'female' | 'both' => {
	if (sex === 'M') return 'male';
	if (sex === 'F') return 'female';
	return 'both';
};